<template>
  <div class="tailwind">
    <component
        :is="coreStore.page"
    />
  </div>

  <Toaster />
  <vue3-confirm-dialog />
</template>

<script>
import { inject } from 'vue';
import {useCoreStore} from "@/stores/CoreStore";
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'

export default {
  name: 'App',
  components:{
    Toaster
  },
  setup() {
    const coreStore = useCoreStore();


    return { coreStore };
  }}
</script>

